
import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-dashboard-line',
      title: 'Switchboard Upgrades',
      description: 'Modern switchboard solutions for homes, businesses, and industrial facilities. Safe power distribution guaranteed.',
      category: 'All Sectors',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Lighting Installations',
      description: 'Energy-efficient lighting solutions from pendant lights to industrial high-bays. Designed for your space.',
      category: 'All Sectors',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Compliance Testing',
      description: 'Comprehensive electrical testing and certification to meet all Australian Standards and regulations.',
      category: 'Commercial & Industrial',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Fault Finding',
      description: 'Expert diagnostics to identify and resolve electrical issues quickly, minimising downtime and disruption.',
      category: 'All Sectors',
    },
    {
      icon: 'ri-plug-line',
      title: 'Power Installations',
      description: 'From single power points to three-phase systems. Complete power solutions for any requirement.',
      category: 'All Sectors',
    },
    {
      icon: 'ri-tools-line',
      title: 'Preventative Maintenance',
      description: 'Scheduled maintenance programs to keep your electrical systems running reliably and efficiently.',
      category: 'Commercial & Industrial',
    },
  ];

  return (
    <section className="py-24 bg-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, #D4AF37 40px, #D4AF37 41px)',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-gold font-bold text-sm tracking-widest uppercase mb-3">WHAT WE DO</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">Core Electrical Services</h2>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto leading-relaxed">
            Professional electrical services delivered with precision and care across all sectors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm p-8 rounded-lg border border-white/10 hover:bg-white/10 hover:border-gold/50 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 rounded-lg bg-gold/20 flex items-center justify-center flex-shrink-0 group-hover:bg-gold transition-all">
                  <i className={`${service.icon} text-gold text-3xl group-hover:text-navy transition-all`}></i>
                </div>
                <div>
                  <span className="text-gold text-xs font-semibold tracking-wider uppercase">{service.category}</span>
                  <h3 className="text-white font-bold text-lg">{service.title}</h3>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border-2 border-gold text-gold px-8 py-4 rounded-full font-bold text-sm tracking-wider hover:bg-gold hover:text-navy transition-all whitespace-nowrap cursor-pointer"
          >
            VIEW ALL SERVICES
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
